// @flow
class SwipeTable {
    el: HTMLElement;

    tolerance = 20;

    constructor(el: HTMLElement) {
        this.el = el;
        this.attachHandlers();
        this.toggleGradients();
    }

    attachHandlers = () => {
        this.el.addEventListener("scroll", this.toggleGradients);
        window.addEventListener("resize", this.toggleGradients);
    };

    showRightGradient = () => {
        this.el.classList.remove("remove-right-gradient");
    };

    hideRightGradient = () => {
        this.el.classList.add("remove-right-gradient");
    };

    showLeftGradient = () => {
        this.el.classList.remove("remove-left-gradient");
    };

    hideLeftGradient = () => {
        this.el.classList.add("remove-left-gradient");
    };

    toggleGradients = () => {
        if (this.el.scrollLeft <= this.tolerance) {
            this.hideLeftGradient();
        } else {
            this.showLeftGradient();
        }

        const scrolledToEnd =
            this.el.clientWidth + this.el.scrollLeft >=
            this.el.scrollWidth - this.tolerance;
        if (scrolledToEnd) {
            this.hideRightGradient();
        } else {
            this.showRightGradient();
        }
    };
}

const els = document.querySelectorAll(".swipe-table");
els.forEach((el: HTMLElement) => {
    new SwipeTable(el);
});
